import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Scaffolding from '../scaffolding/dynamic'
import Header from '../scaffolding/widgets/header'
import Imager from '../scaffolding/widgets/imager'
import Topper from '../scaffolding/widgets/topper'
import Leader from '../scaffolding/widgets/leader'
import Quoter from '../scaffolding/widgets/quoter'
import Lister from '../scaffolding/widgets/lister'
import Linker from '../scaffolding/widgets/linker'
import Boxer from '../scaffolding/widgets/boxer'
import Contacter from '../scaffolding/widgets/contacter'
import Footer from '../footer'
import styles from './styles'

class MethodContent extends Scaffolding {
  constructor(props) {
    super(props)

    this.state = {
      selected: [],
    }

    this.add = this.add.bind(this)
    this.minus = this.minus.bind(this)
  }

  add(item) {
    let selected = this.state.selected
    selected.push(item)
    this.setState({ selected: selected })
  }
  minus(item) {
    let selected = this.state.selected
    let filtered = selected.filter(x => x !== item)
    this.setState({ selected: filtered })
  }

  render() {
    const { data, metadata, policies, classes } = this.props
    const { mapper, topper, contents } = data
    const { selected } = this.state
    this.reset()
    return (
      <div>
        <Header
          image={topper.background_image}
          video={topper.background_video}
          gradient={topper.gradient}
        />
        <div className={classes.mainFloat}>
          <Topper topper={topper} />
          <Leader topper={topper} />
          <Layout
            mapper={mapper}
            contents={contents}
            count={this.count}
            inc={this.inc}
            selected={selected}
            add={this.add}
            minus={this.minus}
          />
        </div>
        <Footer policies={policies} />
      </div>
    )
  }
}

const Layout = props => {
  const { mapper, contents, count, inc, selected, add, minus } = props
  return mapper.map((type, key) => {
    switch (type) {
      case 'quote':
        return (
          <Quoter contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'image':
        return (
          <Imager contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'list':
        return (
          <Lister contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'boxes':
        return (
          <Boxer
            contents={contents}
            type={type}
            inc={inc}
            count={count}
            selected={selected}
            add={add}
            minus={minus}
            key={key}
          />
        )
        break
      case 'contact':
        return (
          <Contacter
            contents={contents}
            type={type}
            inc={inc}
            count={count}
            selected={selected}
            key={key}
          />
        )
        break
      case 'content_link':
        return (
          <Linker contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      default:
        break
    }
  })
}

export default withStyles(styles)(MethodContent)



// WEBPACK FOOTER //
// ./src/components/method/index.js